import { useRoutes } from '@r/hooks/use-routes.ts';

const useRouteExists = (path: string): boolean => {
  const routes = useRoutes();
  return routes.data?.some((route) => route.path === path) ?? false;
};

export { useRouteExists };
